import { render } from "./Dashboard.vue?vue&type=template&id=3c640bf7&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=3c640bf7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3c640bf7"

export default script